import React, { useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import FilterActionWrapper from 'router/subrouters/Dash/subrouters/Business/pages/Businesses/components/filters/FilterActionWrapper';
import useCallbackRef from 'hooks/useCallbackRef';
import { DropdownRef } from 'ncoded-component-library/build/components/molecules/Dropdown/Dropdown.component';
import { Button, Checkbox } from 'ncoded-component-library';

import './FilterMetrics.styles.scss';

export type MetricsFilters = {
  isResolveManagedListing: boolean;
  isPausedListing: boolean;
  isEndedListing: boolean;
};

const FITLER_COPY: Record<keyof MetricsFilters, string> = {
  isResolveManagedListing: 'hideResolveManagedListings',
  isPausedListing: 'hidePausedListings',
  isEndedListing: 'hideEndedListings',
};

type FilterMetricsProps = {
  className?: string;
  setMetricsFilters: (metrics: MetricsFilters) => void;
};

const FilterMetrics: React.FC<FilterMetricsProps> = (props) => {
  const { className, setMetricsFilters } = props;

  const [dropdown, dropdownRef] = useCallbackRef<DropdownRef>();

  const [appliedFilters, setAppliedFilters] = useState<MetricsFilters | null>(
    null,
  );

  const classes = classNames('filter-metrics', className);

  const { t } = useTranslation();

  return (
    <FilterActionWrapper
      ref={dropdownRef}
      className={classes}
      renderAsPortal
      portalClassName="filter-metrics__portal"
      trigerTitle={t('filter')}
    >
      {Object.entries(FITLER_COPY).map(([key, val]) => (
        <Checkbox
          key={key}
          label={t(val)}
          checked={appliedFilters?.[key as keyof MetricsFilters] || false}
          onChange={() => {
            setAppliedFilters((old) => {
              if (old?.[key as keyof MetricsFilters]) {
                const newUP = { ...old };
                delete newUP[key as keyof MetricsFilters];
                return newUP;
              }

              return { ...old, [key]: true };
            });
          }}
        />
      ))}
      <div className="actions">
        <Button
          variant="link"
          onClick={() => {
            setAppliedFilters(null);
            dropdown?.setIsOpen(false);
          }}
        >
          {t('cancel')}
        </Button>
        <Button
          onClick={() => {
            setMetricsFilters(appliedFilters);
            dropdown?.setIsOpen(false);
          }}
        >
          {t('applyFilters')}
        </Button>
      </div>
    </FilterActionWrapper>
  );
};

export default FilterMetrics;
